const {
  phoneRegex,
  emailRegex,
  urlRegex,
} = require('venuescanner-js/utils/regexes');
const { containsPhone, containsEmail } = require('venuescanner-js/utils');
const subscriptions = require('venuescanner-js/constants/subscriptions');
const userType = require('venuescanner-js/constants/user_type');

const cleanUrl = ({ url, variant }) => {
  switch (variant) {
    case 'mailto':
      return url;
    case 'tel':
      return url.replace(/[^+0-9]/g, '');
    case 'url':
      return url;
    default:
      return url;
  }
};
const redactContacts = (msg = '') => {
  if (containsPhone(msg)) {
    msg = msg.replace(phoneRegex, '[REDACTED:tel]');
  }

  if (containsEmail(msg)) {
    msg = msg.replace(emailRegex, '[REDACTED:email]');
  }

  return msg;
};
const contactsToLinks = (msg = '', viewerRole) => {
  const bubbleMessage =
    viewerRole === userType.organiser
      ? 'If you speak to the host outside of your VenueScanner Inbox, make sure to remember to mark your enquiry as booked or closed. This really helps us to know not to chase the host or check in with you for updates.'
      : 'If you take the enquiry offline make sure to update the status as booked if the booking takes place, in line with our platform rules.';
  if (containsPhone(msg)) {
    msg = msg.replace(phoneRegex, match => {
      return `<a class='redacted-link__phone' target='_blank' data-bubble='${bubbleMessage}' href='tel:${cleanUrl(
        { url: match, variant: 'tel' },
      )}'>${match}</a>`;
    });
  }

  if (containsEmail(msg)) {
    msg = msg.replace(emailRegex, match => {
      return `<a class='redacted-link__email' target='_blank' data-bubble='${bubbleMessage}' href='mailto:${cleanUrl(
        { url: match, variant: 'mailto' },
      )}'>${match}</a>`;
    });
  }

  return msg;
};
const urlToLinkAddress = url => {
  if (url.match(/^http/i)) return url;
  if (url.match(/:\/\//i)) return url;
  if (url.match(/^[a-z]/i)) return `https://${url}`;
  return url;
};
const urlsToLinks = (msg = '', viewerRole) => {
  const bubbleMessage =
    viewerRole === userType.organiser
      ? 'If you speak to the host outside of your VenueScanner Inbox, make sure to remember to mark your enquiry as booked or closed. This really helps us to know not chase the host or check in with you for updates.'
      : 'If you take the enquiry offline make sure to update the status as booked if the booking takes place, in line with our platform rules.';

  msg = msg.replace(urlRegex, match => {
    if (match.match(emailRegex)) return match;
    return `<a class='redacted-link__url' target='_blank' data-bubble='${bubbleMessage}' href='${cleanUrl(
      { url: urlToLinkAddress(match), variant: 'url' },
    )}'>${match}</a>`;
  });

  return msg;
};

const possibleRedactMessage = (venue, viewerRole, message) => {
  if (Object.values(subscriptions).includes(venue.sub_plan)) {
    // has a subscription
    return contactsToLinks(message, viewerRole);
  } else {
    return contactsToLinks(message, viewerRole);
  }
};
const possibleRedactUrls = (venue, viewerRole, message) => {
  if (Object.values(subscriptions).includes(venue.sub_plan)) {
    // has a subscription
    return urlsToLinks(message, viewerRole);
  } else {
    return urlsToLinks(message, viewerRole);
  }
};

module.exports = {
  redactContacts,
  contactsToLinks,
  possibleRedactMessage,
  possibleRedactUrls,
};
